export const iconFontAwesomeTravelHotelTrainSubway = (
	<i className="fa-solid fa-train-subway"></i>
);
